import { useMutation, useQueryClient, UseMutationOptions } from '@tanstack/react-query'
import { createApiCall } from 'services'
import { INTERNAL_USERS_QUERY_KEY } from './useInternalUsers'

export type InviteInternalUserPayload = {
  email: string
  role_name: 'platform_admin' | 'platform_manager'
  company_ids?: string[]
}

type InviteInternalUserResponse = {
  message: string
}

export const useInviteInternalUser = (
  options?: Omit<UseMutationOptions<InviteInternalUserResponse, Error, InviteInternalUserPayload>, 'mutationFn'>
) => {
  const queryClient = useQueryClient()

  return useMutation<InviteInternalUserResponse, Error, InviteInternalUserPayload>({
    mutationFn: async (payload) => {
      const response = await createApiCall({
        method: 'POST',
        url: `/invite/admin/${payload.role_name}`,
        data: {
          email: payload.email,
          company_ids: payload.company_ids,
        },
      })

      return response.data as InviteInternalUserResponse
    },
    onSuccess: (data, variables, context) => {
      // Invalidate internal users query to refetch the list
      queryClient.invalidateQueries({ queryKey: [INTERNAL_USERS_QUERY_KEY] })

      // Call custom onSuccess if provided
      options?.onSuccess?.(data, variables, context)
    },
    onError: options?.onError,
    ...options,
  })
}
